export const ListRowChevron = () => (
  <span
    className="inline-flex w-6 shrink-0 translate-y-2 items-center justify-center self-center text-gray-400 dark:text-gray-500"
    aria-hidden
  >
    <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
    </svg>
  </span>
);
